export default {
  getAdminUser (state) {
    return state.adminUser
  },
  getCollapse (state) {
    return state.collapse
  }
}



//////////////////
// WEBPACK FOOTER
// ./store/getters.js
// module id = null
// module chunks = 